import { Box, Typography } from '@mui/material';
import React from 'react';
import { ConfettiCelebration } from '../../../components/ConfettiCelebration';

interface ContestEntryCelebrationProps {
  onComplete: () => void;
}

export const ContestEntryCelebration: React.FC<ContestEntryCelebrationProps> = ({
  onComplete,
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
      aria-label="Contest entry celebration"
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          px: 3,
          textAlign: 'center',
          color: '#111',
        }}
      >
        <Typography
          component="h2"
          sx={{ fontSize: '2rem', fontWeight: 800, lineHeight: 1.1, mb: 1 }}
        >
          Wahoo!
        </Typography>
        <Typography sx={{ fontSize: '1rem', lineHeight: 1.5 }}>
          You&apos;ve earned your raffle entry today.
        </Typography>
      </Box>

      <ConfettiCelebration onComplete={onComplete} duration={2000} zIndex={1} />
    </Box>
  );
};
